module.exports = __webpack_public_path__ + "static/img/dou+.a7fadc46.png";